import axios from 'axios';
import {API} from "@/services/url";

export default {
	getSubscriptionPeriods : function (success, error) {
		axios.get(API.subscriptions.subscriptionPeriodList)
			.then(r => success(r.data.subscriptionPeriodList))
			.catch(e => error(e.response.data.message));
	},

	getPricingOptions : function (success, error) {
		axios.get(API.subscriptions.pricingOptionList)
			.then(r => success(r.data.pricingOptionList))
			.catch(e => error(e.response.data.message));
	},

	getPaymentOptions : function (success, error) {
		axios.get(API.subscriptions.paymentOptionList)
			.then(r => success(r.data.paymentOptionList))
			.catch(e => error(e.response.data.message));
	},

	subscribeAnOffice : function (subscriber, success, error) {
		axios.post(API.subscriptions.subscribe, subscriber)
			.then(r => success(r.data.subscriptionList))
			.catch(e => error(e.response.data.message));
	},

	getAllSubscriptions : function (params, success, error) {
		axios.get(API.subscriptions.all, {
			params : params
		})
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},

	deleteSubscription : function (subscriptionId, success, error) {
		axios.post(API.subscriptions.delete + subscriptionId)
			.then(r => success(r))
			.catch(e => error(e.response.data.message));
	},

	updateSubscription : function (subscriptionId, request, success, error) {
		return axios.post(API.subscriptions.update + subscriptionId, request)
			.then(r => success(r))
			.catch(e => error(e.response.data.message));
	},

	getAllExpiredSubscriptions : function (success, error) {
		axios.get(API.subscriptions.expired)
			.then(r => success(r.data.expiredSubscriptions))
			.catch(e => error(e.response.data.message));
	},

	getSubscriptionRequests : function (params, success, error) {
		axios.get(API.subscriptions.requestList, { params })
			.then(r => success(r.data))
			.catch(e => error(e.response ? e.response.data.message : e.message));
	},

}
